import Button from 'src/components/atoms/button'

export interface Tenant {
    id: string
    label: string
}

interface Props {
    tenant: Tenant
    onSubmit: (tenantId: string) => void
}

const Tenant = (props: Props) => {
    const { tenant, onSubmit } = props

    const handleClick = () => {
        onSubmit(tenant.id)
    }

    return (
        <Button key={`tenant-${tenant.id}`} type="default" className={'w-full cursor-pointer'} onClick={handleClick}>
            {tenant.label}
        </Button>
    )
}

export default Tenant
